import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-itinerary-day",
  templateUrl: "./itinerary-day.component.html",
  styleUrls: ["./itinerary-day.component.css"]
})
export class ItineraryDayComponent implements OnInit {

  constructor() { }

  ngOnInit() { }
}
